const HTML_ESCAPE_MAP = Object.freeze({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
})

export const escapeHtml = (value) => {
  if (value == null) return ""

  return String(value).replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char])
}

export const escapeHtmlList = (values) => {
  if (!Array.isArray(values)) return []

  return values.map((value) => escapeHtml(value))
}
